const TextQue = ({ queTitle }) => {
  return (
    <div className="flex flex-col">
      <h4 className="text-lg font-semibold text-black mb-4">{queTitle}</h4>

      <input
        type="text"
        placeholder="Text answer from employees"
        disabled
        className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-slate-500 cursor-not-allowed"
      />
    </div>
  );
};

export default TextQue;
